export enum DealMilestone {
  QUALIFICATION = 1,
  PPP = 2,
  TECHNICAL_EVALUATION = 3,
  EXECUTIVE_SIGNOFF = 4,
  PROCUREMENT = 5
}
